// extracted by mini-css-extract-plugin
export default {"dialogWrapper":"Dialog_dialogWrapper__lRA+S","dbgSuccess":"Dialog_dbgSuccess__trH9X","dbgError":"Dialog_dbgError__YCqIa"};